import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=10da624f&scoped=true&"
import script from "./forgot.vue?vue&type=script&lang=js&"
export * from "./forgot.vue?vue&type=script&lang=js&"
import style0 from "./forgot.vue?vue&type=style&index=0&id=10da624f&scoped=true&lang=css&"
import style1 from "./forgot.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da624f",
  null
  
)

component.options.__file = "forgot.vue"
export default component.exports